import React, { FC } from 'react';
import { Modules, P70FindStoresPage as P70FindStoresPageProps } from '~/lib/data-contract';
import { DynamicBlockList } from '~/templates/blocks';
import { sortStoreList } from '~/shared/utils';
import { StoreMapList } from '~/features/find-store/components/StoreMap/StoreMapList';
import styles from './P70FindStores.module.scss';
import StoreOverviewSchema from './StoreOverviewSchema';

export const P70FindStoresPage: FC<P70FindStoresPageProps> = (props) => {
    const { data: pageData } = props;

    const storeList = pageData?.storeList?.data ?? [];

    const sortedStoreList = sortStoreList(storeList);

    return (
        <>
            <DynamicBlockList elements={props.pageElements as Modules[]} />
            <StoreOverviewSchema />
            <div className={styles.storeDetailsContainer}>
                <div className={styles.storeDetailsContent}>
                    <StoreMapList storeList={sortedStoreList} />
                </div>
            </div>

            <DynamicBlockList elements={props.bottomPageElements as Modules[]} />
        </>
    );
};
